import withResponsiveHOC from "/components/enhancements/responsive-hoc/responsive-hoc-component";
import CardsGridDesktopComponent from "segments/desktop/grid/layouts/cards-grid/components/cards-grid-desktop/cards-grid-desktop-component";
import CardsGridMobileComponent from "segments/desktop/grid/layouts/cards-grid/components/cards-grid-mobile/cards-grid-mobile-component";
import CardGridDefaultProp from "./components/default-props";
const CardGridComponent = withResponsiveHOC(CardsGridDesktopComponent, CardsGridMobileComponent);
export default CardGridComponent;
CardGridComponent.defaultProps = CardGridDefaultProp;
